<script lang="ts">
  import Journal from '#lib/components/journal/Journal.svelte';
</script>

<svelte:head>
  <title>Coffee Pal - Journal</title>
</svelte:head>

<Journal />
